import React from 'react';
import { Chat } from '@fluentui/react-northstar';
import classnames from 'classnames';
import { createUseStyles } from 'react-jss';
import { MDXEditor, listsPlugin, headingsPlugin } from '@mdxeditor/editor';
import { ChatMessage, MessageProps } from '@azure/communication-react';
import { getCustomTimestamp } from './message-with-actions';
import { INSTRUCTION_TXT, MARKDOWN_PREFIX } from '../DailyPlanner/common';
import { vivaraMessageStyle } from './common-styles';
import { useIsVivara } from '../../hooks/useIsVivara';
import { PlaygroundTheme } from '../../Theme';

interface IMarkdownMessageProps {
  messageProps: MessageProps;
  isUserMessage?: boolean;
}
const useStyles = createUseStyles<string, unknown, PlaygroundTheme>((theme) => ({
  markdownMessage: {
    minWidth: 300,
    // height: 300,
    '& h3': {
      margin: 0,
      fontSize: 16,
      fontWeight: 'normal',
    },
    '& [role=textbox]': {
      padding: 0,
      color: '#fff',
    },
    '& ul': {
      paddingLeft: 32,
      paddingBottom: '0 !important',
    },
    '& [role=checkbox]': {
      lineHeight: '16px',
    },
    '& p': {
      // display: 'none',
      margin: 0,
      '&:last-child': {
        display: 'none',
      },
    },
    '&.is-vivara': {
      ...vivaraMessageStyle(theme),
      '& .mdxeditor-root-contenteditable': {
        fontFamily: 'aptos-serif',
      },
      '& [role=textbox]': {
        padding: 0,
        color: '#000',
      },
      '& h3': {
        margin: '0 0 6px 0',
        fontSize: 14,
      },
      '& p span': {
        fontSize: 14,
      },
      '& span': {
        fontSize: 12,
      },
      '& li[role=checkbox][aria-checked=true]:before': {
        backgroundColor: theme.themePrimary,
      },
      '& li[role=checkbox][aria-checked=true]': {
        textDecoration: 'none',
        '& span': {
          textDecoration: 'line-through',
        },
      },
    },
  },
}));

export const MarkdownMessage: React.FC<IMarkdownMessageProps> = ({
  messageProps,
  isUserMessage,
}) => {
  const message = messageProps.message as ChatMessage;
  const classes = useStyles();
  const legalContent = message.content!
    .replace(MARKDOWN_PREFIX, '')
    .replace(INSTRUCTION_TXT, '')
    .replace(/<br\/?>/g, '\n')
    .replace(/(?!")(\\)?>>(?!")/g, '[Started]')
    .replace(/(\*\s*\[\s*\])(.*)(\\?\[Started\])(.*)/g, (_0, _1, _2, _3, _4) => `${_1.trim()} [Started] ${_2.trim()}${_4.trim()}`)
    .replace(/(\*\s*\[\s*x\s*\])(.*)(\\?\[Started\])(.*)/g, (_0, _1, _2, _3, _4) => `${_1.trim()} ${_2.trim()}${_4.trim()}`);
  const isVivara = useIsVivara();

  return (
    <Chat.Message
      className={classnames(classes.markdownMessage, isUserMessage && 'is-user-message', isVivara && 'is-vivara')}
      timestamp={getCustomTimestamp(message.createdOn)}
      content={{
        content: (
          <MDXEditor
            markdown={legalContent}
            plugins={[
              listsPlugin(),
              headingsPlugin(),
            ]}
            readOnly
          />
        ),
      }}
    />
  );
};
